import React from "react";
import {
  MDBNavbar,
  MDBContainer,
  MDBIcon,
  MDBNavbarBrand,
  MDBAlert,
} from "mdb-react-ui-kit";
//import { useMsal } from "@azure/msal-react";
//import { loginRequest } from "../Auth/authConfig";

const PreHeader = ({
  showListAndNotificationUI,
  setShowListAndNotificationUI,
}) => {
  //const { instance, accounts } = useMsal();
  //const isAuthenticated = accounts.length > 0;

  const toggleOpenListAndNotifications = () =>
    setShowListAndNotificationUI(!showListAndNotificationUI);

  /*const handleLogin = async () => {
        try {
            await instance.loginPopup(loginRequest);
        } catch (e) {
            console.error("Login failed", e);
        }
    };

    const handleLogout = async () => {
        try {
            await instance.logoutPopup();
        } catch (e) {
            console.error("Logout failed", e);
        }
    };*/

  return (
    <MDBNavbar expand="lg" className="bg-color6 p-0 mb-2">
      <MDBContainer fluid>
        <MDBNavbarBrand href="/" className="mb-0 text-white">
          <img width="50px" src="./logo.png" alt="Logo" />
          <span className="d-none d-lg-block">
            Montana Legislative Services
          </span>
          <span className="d-lg-none">MT Legislative</span>
        </MDBNavbarBrand>
        <div className="d-flex justify-content-end align-items-center">
          <a
            href="https://www.billtracker.com/MTPublic"
            className="nav-link text-light"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MDBIcon className="d-none d-sm-inline-block" far icon="external-link" /> Bill Tracker Login
          </a>
        </div>
        <MDBAlert
          show={false}
          color="warning"
          dismissible
          className="m-0 py-2"
          style={{ padding: "0.5rem" }}
        >
          <div>No alerts to display at this time.</div>
        </MDBAlert>
      </MDBContainer>
    </MDBNavbar>
  );
};

export default PreHeader;
